import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import { useLocale } from '../../../../../i18n';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';
import { getFlowInfo } from '../../api/getFlowInfo';
import useFlowsInitNew from '../init/useFlowsInitNew';
import useFlowsResetState from '../useFlowsResetState';
import { SchemaYellowHiveProductsInConversationCmd } from 'wg-api-sdk';

const useStartYellowhiveOfferFlow = () => {
  const { initFlow } = useFlowsInitNew();
  const { userLang } = useLocale();
  const { campaign } = useAuth();
  const { reset } = useFlowsResetState();

  return async ({
    flowId,
    uuid,
    inputUrl,
    partyId,
    quoteId,
    quoteIds,
    yellowhive_products,
    selectedYellowhiveProductId,
  }: {
    flowId: string;
    yellowhive_products?: SchemaYellowHiveProductsInConversationCmd[];
    selectedYellowhiveProductId?: string;
    uuid?: string;
    inputUrl?: string;
    partyId?: string;
    quoteId?: string;
    quoteIds?: string[];
  }) => {
    reset();

    const flowInfo = await getFlowInfo(flowId, { lang: userLang });
    let resolvedYellowhiveProducts:
      | SchemaYellowHiveProductsInConversationCmd[]
      | undefined;

    // If yellowhive_products are explicitly provided, use them
    if (yellowhive_products) {
      resolvedYellowhiveProducts = yellowhive_products;
    }
    // If a specific product was selected in YellowhiveProductSelection page
    else if (selectedYellowhiveProductId) {
      resolvedYellowhiveProducts = [
        {
          id: selectedYellowhiveProductId,
          coverages: [],
        },
      ];
    }
    // Otherwise, try to get products from campaign
    else if (campaign?.yellowhive_products?.items?.length) {
      resolvedYellowhiveProducts = campaign.yellowhive_products.items.map(
        (item) => ({
          id: item.id,
          coverages: item.coverages?.map((coverage) => coverage.code) || [],
        }),
      );
    }

    await initFlow({
      flowId: flowId,
      payload: {
        party_id: partyId,
        quote_id: quoteId,
        quote_ids: quoteIds,
        previous_session_id: flowInfo.previous ? uuid : undefined,
        subject: campaign?.subjects?.length ? campaign.subjects : undefined,
        yellowhive_products: resolvedYellowhiveProducts,
      },
      inputUrl,
      outputUrl: `${FLOWS_PRODUCTS_PATH}/${flowId}/overview${
        uuid ? `?session_id=${uuid}` : ''
      }`,
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartYellowhiveOfferFlow;
